var map = {
	"./bass_0.mp3": 286,
	"./bells_0.mp3": 287,
	"./bells_1.mp3": 288,
	"./bells_2.mp3": 289,
	"./bells_3.mp3": 290,
	"./bells_4.mp3": 291,
	"./bells_5.mp3": 292,
	"./bells_6.mp3": 293,
	"./bells_7.mp3": 294,
	"./bells_8.mp3": 295,
	"./bells_9.mp3": 296,
	"./drumkit_0.mp3": 297,
	"./drumkit_1.mp3": 298,
	"./drumkit_2.mp3": 299,
	"./drumkit_3.mp3": 300,
	"./drumkit_4.mp3": 301,
	"./drumkit_5.mp3": 302,
	"./drumkit_6.mp3": 303,
	"./drumkit_7.mp3": 304,
	"./drumkit_8.mp3": 305,
	"./drumkit_9.mp3": 306,
	"./jazzy_bass_0.mp3": 307,
	"./jazzy_bass_1.mp3": 308,
	"./jazzy_bass_2.mp3": 309,
	"./jazzy_bass_3.mp3": 310,
	"./jazzy_bass_4.mp3": 311,
	"./jazzy_bass_5.mp3": 312,
	"./jazzy_bass_6.mp3": 313,
	"./jazzy_bass_7.mp3": 314,
	"./jazzy_bass_8.mp3": 315,
	"./jazzy_bass_9.mp3": 316,
	"./piano_0.mp3": 317,
	"./piano_1.mp3": 318,
	"./piano_2.mp3": 319,
	"./piano_3.mp3": 320,
	"./piano_4.mp3": 321,
	"./piano_5.mp3": 322,
	"./piano_6.mp3": 323,
	"./piano_7.mp3": 324,
	"./piano_8.mp3": 325,
	"./piano_9.mp3": 326,
	"./piano_chords_0.mp3": 327,
	"./piano_chords_1.mp3": 328,
	"./piano_chords_2.mp3": 329,
	"./piano_chords_3.mp3": 330,
	"./piano_chords_4.mp3": 331,
	"./piano_chords_5.mp3": 332,
	"./piano_chords_6.mp3": 333,
	"./piano_chords_7.mp3": 334,
	"./piano_chords_8.mp3": 335,
	"./piano_chords_9.mp3": 336,
	"./punchy_bass_0.mp3": 337,
	"./punchy_bass_1.mp3": 338,
	"./punchy_bass_2.mp3": 339,
	"./punchy_bass_3.mp3": 340,
	"./punchy_bass_4.mp3": 341,
	"./punchy_bass_5.mp3": 342,
	"./punchy_bass_6.mp3": 343,
	"./punchy_bass_7.mp3": 344,
	"./punchy_bass_8.mp3": 345,
	"./punchy_bass_9.mp3": 346,
	"./saw_lead_0.mp3": 347,
	"./saw_lead_1.mp3": 348,
	"./saw_lead_2.mp3": 349,
	"./saw_lead_3.mp3": 350,
	"./saw_lead_4.mp3": 351,
	"./saw_lead_5.mp3": 352,
	"./saw_lead_6.mp3": 353,
	"./saw_lead_7.mp3": 354,
	"./saw_lead_8.mp3": 355,
	"./saw_lead_9.mp3": 356,
	"./synth_chords_0.mp3": 357,
	"./synth_chords_1.mp3": 358,
	"./synth_chords_2.mp3": 359,
	"./synth_chords_3.mp3": 360,
	"./synth_chords_4.mp3": 361,
	"./synth_chords_5.mp3": 362,
	"./synth_chords_6.mp3": 363,
	"./synth_chords_7.mp3": 364,
	"./synth_chords_8.mp3": 365,
	"./synth_chords_9.mp3": 366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 285;